import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import axiosInstance from 'src/utils/axios';

type Props = {
  src: string;
  alt?: string;
  sx?: object;
  onClick?: VoidFunction;
  onLoaded?: (objectUrl: string) => void;
};

export default function AuthenticatedImage({ src, alt, sx, onClick, onLoaded }: Props) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    let url: string | null = null;
    setStatus('loading');

    axiosInstance
      .get(src, { responseType: 'blob' })
      .then((response) => {
        url = URL.createObjectURL(response.data);
        setObjectUrl(url);
        setStatus('success');
        onLoaded?.(url);
      })
      .catch(() => setStatus('error'));

    return () => {
      if (url) URL.revokeObjectURL(url);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  if (status === 'loading') return <CircularProgress size={24} />;
  if (status === 'error') return <Box sx={{ color: 'text.disabled' }}>No image uploaded</Box>;

  return (
    <Box
      component="img"
      src={objectUrl ?? undefined}
      alt={alt}
      onClick={onClick}
      sx={{ borderRadius: 1, ...(onClick && { cursor: 'pointer' }), ...sx }}
    />
  );
}
